// @flow

import { trackEvent } from 'dibs-tracking';

const trackingObj = {
    action: 'email a friend sent',
    category: 'email a friend',
    value: 0,
};

export const trackPdpEvent = ({ itemId }: { itemId: string }) => {
    const label = `item|${itemId}`;
    trackEvent({
        ...trackingObj,
        label,
    });
};

export const trackFavoritesEvent = ({
    type = 'item',
    itemCount,
    hasNote = false,
}: {
    type: string,
    itemCount: number,
    hasNote: boolean,
}) => {
    let label = type;
    let value = 0;

    if (type === 'item' && itemCount > 1) {
        label = 'multiple items';
    }
    if (hasNote) {
        value = 1;
    }

    if (label) {
        trackEvent({
            ...trackingObj,
            label,
            value,
        });
    }
};
